import { serverCRMConfig } from 'config'

export const getApiBaseUrl = () =>
    String(serverCRMConfig?.APIURL || '').replace(/\/+$/, '')

export const getApiKey = () => String(serverCRMConfig?.apiKey || '').trim()

export const buildApiUrl = (route = '') => {
    const baseUrl = getApiBaseUrl()
    const normalizedRoute = String(route || '').replace(/^\/+/, '')
    const apiKey = getApiKey()
    const separator = normalizedRoute.includes('?') ? '&' : '?'

    return `${baseUrl}/${normalizedRoute}${separator}apiKey=${encodeURIComponent(apiKey)}`
}

const isApiErrorPayload = (payload) => !!(
    payload &&
    typeof payload === 'object' &&
    (payload.error || payload.__error || payload.result === 'error')
)

export const toMockResponse = (response) => {
    const payload = response?.data ?? {}
    return [isApiErrorPayload(payload) ? 400 : 200, payload]
}

export const toMockErrorResponse = (error, fallbackMessage) => {
    const status = Number(error?.response?.status) || 500
    const payload = error?.response?.data

    if (payload && typeof payload === 'object') {
        return [status, payload]
    }

    return [status, {
        error: 'Proxy Error',
        errorInfo: String(payload || error?.message || fallbackMessage),
        result: 'error',
    }]
}
